import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import Images from "assets/images/imageData";
import localization from "assets/localization/localization";
import ListFilters from "components/sales/ListFilters/ListFilters";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";

const CompetitionMappingList = ({
  getCompetitionMappingData,
  competititonMappingResponse = [],
}) => {
  const headers = [
    "Site Name",
    "Barrier Installed",
    "Barrier Brand",
    "Other Barrier Brand",
    "Society Entrance Image",
    "Barrier Closeup Image",
    "Solution Type",
    // "Guard Remarks",
    "Created By",
    "Created At",
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isRoleId, setIsRoleId] = useState();
  const { baseUrl } = useContext(BaseUrl);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link to={`${baseUrl}/competition-mapping`} className="btn btn-primary">
          {"Add New Site"}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getCompetitionMappingData(1);
      setIsLoading(false);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getCompetitionMappingData(val.selected + 1);
    setIsLoading(false);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem(
      "competition_mapping_list_filter",
      JSON.stringify(filterData)
    );
    setListData([]);
    setIsLoading(true);
    setFilterData(filterData);
    await getCompetitionMappingData(1, filterData);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    const tableData = [
      "site_name",
      "barrier_installed",
      "barrier_brand",
      "other_barrier_brand",
      "society_entrance_image",
      "barrier_closeup_image",
      "solution_type",
      //   "guard_remarks",
      "created_by_name",
      "created_at_formatted",
    ];

    if (competititonMappingResponse && competititonMappingResponse.data) {
      const data = competititonMappingResponse.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => {
            let value = element[key];

            // Show clickable image icon
            if (key === "society_entrance_image" || key === "barrier_closeup_image") {
                value = value ? (
                  <a href={value} target="_blank" rel="noopener noreferrer" title="View Image">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ cursor: "pointer" }}
                    >
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                      <circle cx="12" cy="12" r="3" />
                    </svg>
                  </a>
                ) : (
                  "-"
                );
              }              
            return {
              [key]: value,
            };
          })
        )
      );

      setListData(data.length > 0 ? data : []);
      setPageCount(
        Math.ceil(
          competititonMappingResponse.total /
            competititonMappingResponse.per_page
        )
      );
    }
  }, [competititonMappingResponse]);

  console.log("competititonMappingResponse", competititonMappingResponse.cities_dropdown)
  

  return (
    <Layout
      title={"Competition Mapping List"}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={competititonMappingResponse?.from}
        onPageChange={onPageChange}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        competitionMappingFilter
        cityDropdown={competititonMappingResponse?.cities_dropdown}
        createdByDropdown={competititonMappingResponse?.created_by_dropdown}
      />
    </Layout>
  );
};

export default CompetitionMappingList;
